import * as types from "../actions/actionTypes";
const initialState = {
  is_fetched: false,
  loading: true,
  data: [],
  constructionPhase: {},
  last_item: "",
  last_child: "",
  storeStatus: false,
  fav_loading: 0
};

const ConstructionPhase = (state = initialState, action) => {
  let data, constructionPhase, thenChildren;
  switch (action.type) {
    // case types.CONSTRUCTION_PHASE_LIST_REQUEST:
    //   return { ...state, loading: true };
    // case types.CONSTRUCTION_PHASE_LIST_SUCCESS:
    //   return {
    //     ...state,
    //     data: action.payLoad,
    //     loading: false,
    //     is_fetched: true
    //   };
    // case types.CONSTRUCTION_PHASE_LIST_FAILURE:
    //   return { ...state, loading: false };

    case types.CONSTRUCTION_PHASE_ALL_REQUEST:
      return { ...state, loading: true };
    case types.CONSTRUCTION_PHASE_ALL_SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        loading: false,
        is_fetched: true
      };
    case types.CONSTRUCTION_PHASE_ALL_FAILURE:
      return { ...state, loading: false };

    case types.CONSTRUCTION_PHASE_SHOW_REQUEST:
      return { ...state, constructionPhase: {}, loading: true };
    case types.CONSTRUCTION_PHASE_SHOW_SUCCESS:
      return {
        ...state,
        constructionPhase: action.payLoad,
        loading: false,
        is_fetched: true
      };
    case types.CONSTRUCTION_PHASE_SHOW_FAILURE:
      return { ...state, loading: false };

    case types.CONSTRUCTION_PHASE_STORE_REQUEST:
      return { ...state, loading: true };
    case types.CONSTRUCTION_PHASE_STORE_SUCCESS:
      data = [...state.data];
      if (action.payLoad.parent_id) {
        data.forEach((item, i) => {
          if (Number(item.id) === Number(action.payLoad.parent_id)) {
            if (!data[i]["children"]) {
              data[i]["children"] = [];
            }
            data[i]["children"].push(action.payLoad);
          }
        });
      } else {
        data.push(action.payLoad);
      }

      constructionPhase = { ...state.constructionPhase };
      if (constructionPhase.id === action.payLoad.parent_id) {
        var children = constructionPhase.children
          ? [...constructionPhase.children]
          : [];
        children.push(action.payLoad);
        constructionPhase = { ...constructionPhase, children };
      }
      return {
        ...state,
        data: data,
        constructionPhase: constructionPhase,
        last_item: action.payLoad,
        loading: false,
        storeStatus: true
      };
    case types.CONSTRUCTION_PHASE_STORE_FAILURE:
      return { ...state, loading: false, storeStatus: false };

    case types.CONSTRUCTION_PHASE_UPDATE_REQUEST:
      return { ...state, loading: true, storeStatus: false };
    case types.CONSTRUCTION_PHASE_UPDATE_SUCCESS:
      data = [];
      if (state.data.length) {
        data = state.data.map(item =>
            {
              if (item.id === Number(action.payLoad.id)){
                return { ...action.payLoad, children: item.children }
              }
              else if(item.id === Number(action.payLoad.parent_id)){
                // return { ...item, children: action.payLoad }
                thenChildren = item.children.map((child =>{
                  if(child.id === Number(action.payLoad.id)){
                    return {...action.payLoad, children: child.children};
                  }
                  else {
                    return child
                  }
                }));
                return {...item, children: thenChildren}
              }
              else{
                return item
              }
            }
        );
      }
      constructionPhase = { ...state.constructionPhase };
      if (constructionPhase.id === Number(action.payLoad.id)) {
        constructionPhase = {
          ...action.payLoad,
          children: [...state.constructionPhase.children]
        };
      }
      return {
        ...state,
        data: data,
        constructionPhase: constructionPhase,
        loading: false,
        is_fetched: true,
        storeStatus: true
      };
    case types.CONSTRUCTION_PHASE_UPDATE_FAILURE:
      return { ...state, loading: false, storeStatus: false };

    case types.CONSTRUCTION_PHASE_ADD_FAVORITE_REQUEST:
      return { ...state, fav_loading: action.id };
    case types.CONSTRUCTION_PHASE_ADD_FAVORITE_SUCCESS:
      data = JSON.parse(JSON.stringify(state.data)); // because deepCopy is needed :)
      data = data.map(item => {
        if (item.id === Number(action.payLoad.id)) {
          return {...item,is_favorite:action.payLoad.is_favorite};
        } else {
          if (item.children) {
            item.children.forEach((child,i) => {
              if (child.id === Number(action.payLoad.id)) {
                item.children[i]= {...child,is_favorite:action.payLoad.is_favorite};
              }
            });
          }
          return item;
        }
      });

      return { ...state, data: data, fav_loading: 0, is_fetched: false };
    case types.CONSTRUCTION_PHASE_ADD_FAVORITE_FAILURE:
      return { ...state, fav_loading: 0 };

    case types.CONSTRUCTION_PHASE_REMOVE_REQUEST:
      return { ...state, loading: true };
    case types.CONSTRUCTION_PHASE_REMOVE_SUCCESS:
      data = JSON.parse(JSON.stringify(state.data)); // because deepCopy is needed :)
      data = data.filter(item => item.id !== Number(action.payLoad.id));
      data.forEach(function(item) {
        item.children = item.children.filter(child => child.id !== Number(action.payLoad.id));
      });
      return { ...state, data: data, loading: false };
    case types.CONSTRUCTION_PHASE_REMOVE_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default ConstructionPhase;
